import styles from './styles.module.scss';

import cn from 'classnames';
import { useEffect, useState } from 'react';
import Button from '../../Buttons/Button';

const Switch = ({ switched, disabled = false, className, onClick = () => {}, ...props }) => {
  const [isSwitch, changeSwitch] = useState(switched);

  const onClickSwitch = () => {
    changeSwitch(!isSwitch);
    onClick(!isSwitch);
  };
  useEffect(() => {
    changeSwitch(switched);
  }, [switched]);
  
  return (
    <Button
      type="switch"
      className={cn(
        styles.switch_block,
        className,
        isSwitch ? styles.switched : styles.no_switched,
        disabled && styles.disabled,
        props.styles,
      )}
      style={props.style}
      onClick={disabled ? () => {} : onClickSwitch}
    >
      <div
        className={cn(styles.circle, isSwitch ? styles.to_right : styles.to_left, disabled && styles.switch_disabled)}
      />
    </Button>
  );
};

export default Switch;
